import Vue from "vue";
import "swiper/dist/css/swiper.css";
import VueAwesomeSwiper from "vue-awesome-swiper";

Vue.use( VueAwesomeSwiper );
